<template>
	<div>
		<v-autocomplete
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:items="items"
			:loading="loading"
			:name="param.name"
			item-text="name"
			item-value="id"
			:search-input.sync="search"
			:multiple="multiple"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			placeholder="Rechercher un bundle"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>

			<template v-slot:item="{ tile, item }">
				<v-list-tile-avatar v-if="multiple">
					<v-icon v-if="tile.props.value" color="primary">check_box</v-icon>
					<v-icon v-else>check_box_outline_blank</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title>
						{{ item.name }}
					</v-list-tile-title>
					<v-list-tile-sub-title class="font-italic caption">
						{{ item.description }}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action>
					#{{ item.id }}
				</v-list-tile-action>
			</template>
		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			ids: [],
			search: null,
			loading: false
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-bundleid') === 0
		}
	},
	watch: {
		search (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.bundleSearch(val)
			}
		},
		value (val) {
			if (Array.isArray(val)) {
				let needGetBundles = false
				val.map(id => {
					if (this.ids.indexOf(id) === -1) needGetBundles = true
				})
				if (needGetBundles) this.searchBundles(val)
			} else {
				if (val && this.ids.indexOf(val) === -1) this.searchBundles(val)
			}
		}
	},
	methods: {
		bundleSearch: debounce(function (search) {
			if (!search) return
			if (search.length < 3 && isNaN(parseInt(search))) return
			if (this.loading) return
			this.searchBundles(search)
		}, 100),
		searchBundles (search) {
			this.loading = true
			this.$EsMaestro.bundle_search(search)
				.then(bundles => {
					this.items = bundles
					this.ids = this.items.map(bundle => bundle.id)
					if (bundles.length === 1) {
						let value = bundles[0].id
						if (parseInt(search) === value) {
							if (this.multiple) value = [ value ]
							this.$emit('update:value', value)
						}
					}
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => (this.loading = false))
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value)) {
				if (value.length === 0) return 'Requis'
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.value) this.searchBundles(this.value)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/bundleid.vue